<template>
    <div class="popup popup-faq modal-in" id="faqPopup">
        <div class="shorexDetail-title js-returnDetailBtn">
            <p>常见问题</p>
            <a class="shorexDetail-returnButton" @click="goBack()">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
            </a>
        </div>
        <div class="ruleDetail" ref="ruleDetail">
            <div class="packageRuleDetail">
                <div class="rule-item">
                    <div class="rule-item-text">
                        <div class="faq-content" v-for="(faqItem, i) in faqItems" :key="i"
                        :class="{ active: selectedIndex == i}" >
                            <div class="faq-question" @click="selectFaq($event, i)">
                                <p class="visa_right__titlt">
                                    {{faqItem.title}}
                                    <img class="faq-hot" src="https://resource.rcclchina.com.cn/Home/new/faq-hot.png">
                                </p> 
                                <span class="faq-question-arrow" aria-hidden="true"></span>
                            </div>
                            <div class="faq-answer">
                                <div class="modal-text">
                                    <div class="item_answer" v-html="faqItem.content" v-show="selectedIndex == i" @click="checkNeedShowPopup">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <router-link to="/content/faq" class="faq-more external">查看更多问题</router-link>
                </div>
            </div>
        </div>
        <bank-popup 
            :onGoBack="closeBankPopup"
            :isShow="isShowBankPopup"
        />
    </div>
</template>

<script>
const BankPopup = () => import('@/components/Booking/BankPopup')
import api from '@/api'
export default {
    name: "TopFaq",
    components: {
        BankPopup
    },
    data() {
        return {
            faqItems: [],
            selectedIndex: -1,
            isShowBankPopup: false
        }
    },
    beforeMount() {
        this.$store.commit('SET_PAGE_TITLE', '')
        this.initPage()
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: true, isHideFooter: true})

        window.onpopstate = () => {
            if (this.isShowBankPopup) {
                this.closeBankPopup()
            } 
        }
    },
    beforeDestroy () {
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: false})
        window.onpopstate = () => {}
    },
    methods: {
        async initPage() {
            const { data } = await api.page.getTopFaq()
            if (data && data.length > 0) {
                this.faqItems = data
            }
        },
        goBack () {
            this.$router.go(-1)
        },
        selectFaq(e, index) {
            this.selectedIndex = this.selectedIndex == index ? -1: index
            setTimeout(()=> {
                const top = e.target.offsetTop
                this.$refs.ruleDetail.scroll({ top: top - 65, behavior: 'smooth' })
            })
        },
        checkNeedShowPopup (e) {
            if (e.target.nodeName === "A") {
                if (e.target.className && e.target.className.indexOf('mogenBankBtn') >= 0) {
                    this.showBankPopup()
                }
            }
        },
        closeBankPopup () {
            this.isShowBankPopup = false
        },
        showBankPopup () {
            this.isShowBankPopup = true
            history.pushState({ page: 'topFaq' }, null);
        }
    }
}
</script>

<style lang="less" scoped>
#faqPopup {
    display: block;
    position: fixed;
    height: 100%;
}

#faqPopup .visa_right__titlt {
    width: 90%;
    display: inline-block;
    vertical-align: top;
    margin-top: 0px !important;
}

#faqPopup .faq-content {
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3eeee;
}

#faqPopup .faq-answer {
    display: none;
    padding-top: 10px;
}

#faqPopup table {
    border: none;
    border-color: #e0e0e0;
}

#faqPopup .faq-answer b {
    margin-top: 5px;
}

#faqPopup .faq-question .faq-question-arrow {
    display: inline-block;
    float: right;
    width: 8px;
    height: 8px;
    border-top: 1px solid #333;
    border-right: 1px solid #333;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    margin-top: 6px;
}

#faqPopup .faq-content.active .faq-question-arrow{
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
}

#faqPopup .faq-content.active .faq-answer {
    display: block;
}


#faqPopup .faq-question {
    color: #333;
    font-weight: bold;
}

#faqPopup .faq-more {
    display: block;
    width: 126px;
    text-align: center;
    height: 24px;
    line-height: 24px;
    border: 1px solid #4A90E2;
    border-radius: 25px;
    border-radius: 25px;
    color: #4A90E2;
    font-size: 14px;
    margin: 20px auto 0px auto;
}

#faqPopup .shorexDetail-title {
    padding: 15px 20px;
    background-color: #fff;
    overflow: hidden;
    text-align: center;
    margin-bottom: 10px;
    position: fixed;
    width: 100%;
    z-index: 10;
}

#faqPopup .shorexDetail-title > p {
    
    font-size: 14px;
    color: #333333;
    letter-spacing: 1px;
    text-align: center;
    margin: 0;
}

#faqPopup .shorexDetail-returnButton {
    width: 30px;
    position: absolute;
    top: 15px;
    left: 20px;
    text-align: left;
}

#faqPopup .ruleDetail {
    margin-top: 60px;
    height: calc(100% - 60px);;
    overflow: scroll;
    padding-bottom: 60px;
}

#faqPopup .rule-item .rule-item-text p {
    margin: 0px;
    font-weight: bold;
}

#faqPopup .rule-item .rule-item-title {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 17px 0 7px;
    font-size: 14px;
    line-height: 20px;
    color: #4A90E2;
    font-weight: bold;
}

#faqPopup .rule-item {
    margin-bottom: 10px;
    padding: 0 20px 12px;
    font-size: 12px;
    line-height: 20px;
    color: #666;
    letter-spacing: 0;
    background-color: #fff;
}

#faqPopup .shorexDetail-returnButton > img {
    width: 33%;
} 


#faqPopup .faq-hot {
    display: inline-block;
    width: 20px;
}


</style>
